import { isMetaCampaignOnly } from 'common/config/acl'
import PickListsContainer from 'containers/Fulfillment/Picklist/Assignment'
import HomePage from 'containers/Home'
import useACL from 'hooks/useACL'
import React from 'react'
import { isIndia } from 'utils/commonUtils'

// Meta campaign users see the daily sales report (picklist table) as their dashboard
const IndexPage = () => {
  const { userRoles } = useACL()

  return isIndia && isMetaCampaignOnly(userRoles) ? (
    <PickListsContainer />
  ) : (
    <HomePage />
  )
}

IndexPage.auth = HomePage.auth

export default IndexPage
